/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
//@ts-ignore
import Parse from 'parse';
//@ts-ignore
import Hero from './../hero/./hero';
//@ts-ignore
import BackButton from './../back-button/./back-button';
//@ts-ignore
import {GetLocalText,GetLocalizedText,GetLocalizedPrice,StripHtml,CapitalizeFirstLetter,GenerateProductAssetUrl} from "./../../themes/kent/utilities/functions";
//@ts-ignore
import {GeneralAssetUrl} from "./../../themes/kent/utilities/constants";

interface IProps {
  submitOrder?:any;
  updateCustomSacPrice?:any;
  year?:any;
}

interface IState {
  customPrice?:any;
  height?:any;
  width?:any;
  length?:any;
  flang?:any;
  style?:any;
  products?:any;
  onBackgroundImageLoaded?:any;
  price?:any;
}

/**
 *
 * Tagged Image component
 * @extends {React.Component}
 */

class FatsacCalculator extends React.Component<IProps> {

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      customPrice:0,
      height:0,
      width:0,
      length:0,
      flang:0,
      style:""
    };
  }

  public componentDidMount = async() => {

    if(this.props.submitOrder){
      this.setState({
        placeOrder:true
      })
    }
    let existingAccessories:any = [];
    if(localStorage.getItem("customSacOrder")){
      let existingOrderString:any = localStorage.getItem("customSacOrder");
      let existingOrder:any = JSON.parse(existingOrderString);
      existingAccessories = existingOrder.accessoriesArray;
      this.setState({
        height:existingOrder.height,
        width:existingOrder.width,
        length:existingOrder.length,
        flang:existingOrder.flang,
        style:existingOrder.style
      })
    }
    let year = this.props.year ? this.props.year :'2022';
    let Products:any = Parse.Object.extend("Products"+year);
    let query:any = new Parse.Query(Products);
    query.equalTo('subcategory', "pTjEjHjeaa");
    query.ascending('order')
    let results:any = await query.find()
    let products:any = []
    results.map((data:any, index:any)=>{
      let product:any = data
      product["selected"] = false;
      product["quantity"] = 1;
      products.push(data)
      if(index == results.length -1){
        if(existingAccessories.length > 0){
          existingAccessories.map((value:any, index:any)=>{
            products.map((data:any, index:any)=>{
              if(data.attributes.slug == value.slug){
                let updatedProduct:any = data;
                updatedProduct["selected"] = true;
                updatedProduct["quantity"] = value.quantity;
                products[index] = updatedProduct;
              }
              if(index == products.length -1){
                this.setState({
                  'products':products
                },()=>{
                  this.calculatePrice()
                })
              }
            })
          })
        } else{
          this.setState({
            'products':products
          },()=>{
            this.calculatePrice()
          })

        }
      }
    })
  }

  public calculatePrice = () => {
    let shapeFee:any = 0;
    let labor:any = 140; // it was 120
		let design:any = 30;
    let additionalMaterialFee:any = 80; // it was 60
    let accessoriesArray:any = []
		let accessories:any = '\n';
		let height:any = parseInt(this.state.height);
		let width:any =  parseInt(this.state.width);
		let length:any =  parseInt(this.state.length);
		let flang:any =  parseInt(this.state.flang);
		let style:any =  this.state.style;
    if(style == "enzo"){
      shapeFee =30
    }
    if(style == "integratedbow"){
      shapeFee =60
    }
    if(style == "tophat"){
      shapeFee =85
    }

		let cost:any = (((((((length * 2) + (width * 2) + (height * 2)) / 12) * 2) * 3) + labor) + design) + ((5.5 * flang) * 2)+shapeFee+additionalMaterialFee;

		//calculate all of the products
    if(this.state.products){
      this.state.products.map((data:any, index:any)=>{
        if(data.selected){
          let price:any = parseInt(data.attributes.content[0].price) *  parseInt(data.quantity);
          accessoriesArray.push({slug:data.attributes.slug,quantity:data.quantity});
          accessories = accessories+" accessory: "+data.attributes.content[0].title + " quantity: "+data.quantity+" total: $"+price+",";
          cost = cost+price
        }
        if(index == this.state.products.length -1){
          let cents:any = cost * 100;
      		let roundedCents:any = Math.round(cents);
      		let roundedPrice:any = roundedCents / 100;
          this.setState({
            customPrice : roundedPrice
          })
          let customSacOrder:any = {
          	"height": height,
  					"width": width,
  					"length": length,
  					"flang": flang,
  					"style": style,
  					"labor": labor,
  					"design": design,
            "additional material fee": additionalMaterialFee,
  					"cost": roundedPrice,
  					"accessories": accessories,
            "accessoriesArray":accessoriesArray
          }
          this.setState({
            price:roundedPrice
          })
          localStorage.setItem("customSacOrder", JSON.stringify(customSacOrder));
        }
      })
    }
	}
  public submitOrder = () => {
    this.calculatePrice()
  }
  public updateLength = (e:any) =>{
    this.setState({
      length: e.target.value
    }, () => {
     this.calculatePrice();
    })
  }
  public updateHeight = (e:any) =>{
    this.setState({
      height: e.target.value
    }, () => {
     this.calculatePrice();
    })
  }
  public updateWidth = (e:any) =>{
    this.setState({
      width: e.target.value
    }, () => {
     this.calculatePrice();
    })
  }
  public updateFlang = (e:any) =>{
    this.setState({
      flang: e.target.value
    }, () => {
     this.calculatePrice();
    })
  }


  public selectStyle = (value:any) => {
    this.setState({
      style:value
    }, () => {
     this.calculatePrice();
    })
  }

  public updateAccessories = (index:any) =>{
    let products:any = this.state.products;
    if(products[index].selected){
      products[index].selected = false
      products[index].quantity = 0;
    } else{
        products[index].selected = true
    }
    this.setState({
      products:products
    }, () => {
     this.calculatePrice();
    })
  }
  public updateAccessoryQuantity = (index:any,value:any) =>{
    let products:any = this.state.products;
    products[index].quantity = value;
    if(value == ""){
      products[index].selected = false
    } else{
      products[index].selected = true
    }
    this.setState({
      products:products
    }, () => {
     this.calculatePrice();
    })
  }

  clearLocalStorage = () =>{
		localStorage.removeItem("customSacOrder")
		window.location.assign('/calculator')
	}

  public render(): JSX.Element {
    let prodAssetUrl:string = GenerateProductAssetUrl(this.props.year);
    return (
      <div className="sac-calculator-container">
        <div className="white-background">
          <h3 className="small-padding centered-text">{'Enter Your Dimensions'}</h3>
          <div className="row max-width-container">
            <div className="small-12 medium-3 tiny-padding">
              <div className="white-background shadow tiny-padding" style={{borderTop:"8px solid #0062e7"}}>
                <p>{'Length (Inches)'}</p>
                <input type="text" value={this.state.length} onChange={this.updateLength} />
              </div>
            </div>
            <div className="small-12 medium-3 tiny-padding">
              <div className="white-background shadow tiny-padding" style={{borderTop:"8px solid #0062e7"}}>
                <p>{'Width (Inches)'}</p>
                <input type="text" value={this.state.width}  onChange={this.updateWidth} />
              </div>
            </div>
            <div className="small-12 medium-3 tiny-padding">
              <div className="white-background shadow tiny-padding" style={{borderTop:"8px solid #0062e7"}}>
                <p>{'Height (Inches)'}</p>
                <input type="text" value={this.state.height}  onChange={this.updateHeight} />
              </div>
            </div>
            <div className="small-12 medium-3 tiny-padding">
              <div className="white-background shadow tiny-padding" style={{borderTop:"8px solid #0062e7"}}>
                <p>{'Flange Valves'}</p>
  							<select value={this.state.flang} onChange={this.updateFlang} className="full-width" style={{"height":'45px'}}>
  								<option value="1">1</option>
  								<option value="2">2</option>
  								<option value="3">3</option>
  								<option value="4">4</option>
  								<option value="5">5</option>
  								<option value="6">6</option>
  								<option value="7">7</option>
  								<option value="8">8</option>
  								<option value="9">9</option>
  								<option value="10">10</option>
  							</select>
              </div>
            </div>
          </div>
        </div>
        <div className="slant light-grey-background">
          <div className="small-padding-left">
            <h3 className="small-padding centered-text">{'Choose Your Style'}</h3>
          </div>
          <div className="row">
            <div shape-option option-value="0" className="custom-option small-12 medium-3 tiny-padding shape-option">
              <div className={this.state.style == "rectangle" ? "selected" : "deselected"}>
                <div className="tiny-padding white-background shadow centered-text" style={{cursor:'pointer'}}>
                  <img className="full-width" src={GeneralAssetUrl+"rectangular.png"} />
                  <h6 option-name>{'Rectangle'}</h6>
                  <p>{'No Extra Fee'}</p>
                </div>
                <div className="small-padding centered-text">
                  <img className="square icon-40 checkmark" src={GeneralAssetUrl+"square-grid.png"} onClick={()=>this.selectStyle("rectangle")} style={{margin:'auto'}} />
                </div>
              </div>
            </div>
            <div shape-option option-value="20" className="custom-option small-12 medium-3 tiny-padding shape-option">
              <div className={this.state.style == "enzo" ? "selected" : "deselected"}>
                <div className="tiny-padding white-background shadow centered-text" style={{cursor:'pointer'}}>
                  <img className="full-width" src={GeneralAssetUrl+"enzo.png"} />
                  <h6 option-name>{'Enzo'}</h6>
                  <p>{'$30 Fee'}</p>
                </div>
                <div className="small-padding centered-text">
                  <img className="square icon-40 checkmark" src={GeneralAssetUrl+"square-grid.png"} onClick={()=>this.selectStyle("enzo")} style={{margin:'auto'}} />
                </div>
              </div>
            </div>
            <div shape-option option-value="50" className="custom-option small-12 medium-3 tiny-padding shape-option">
              <div className={this.state.style == "integratedbow" ? "selected" : "deselected"}>
                <div className="tiny-padding white-background shadow centered-text" style={{cursor:'pointer'}}>
                  <img className="full-width" src={GeneralAssetUrl+"integrated-bow.png"} />
                  <h6 option-name>{'Integrated Bow'}</h6>
                  <p>{'$60 Fee'}</p>
                </div>
                <div className="small-padding centered-text">
                  <img className="square icon-40 checkmark" src={GeneralAssetUrl+"square-grid.png"} onClick={()=>this.selectStyle("integratedbow")} style={{margin:'auto'}} />
                </div>
              </div>
            </div>
            <div shape-option option-value="75" className="custom-option small-12 medium-3 tiny-padding shape-option">
              <div className={this.state.style == "tophat" ? "selected" : "deselected"}>
                <div className="tiny-padding white-background shadow centered-text" style={{cursor:'pointer'}}>
                  <img className="full-width" src={GeneralAssetUrl+"top-hat.png"} />
                  <h6 option-name>{'Top Hat'}</h6>
                  <p>{'$85 Fee'}</p>
                </div>
                <div className="small-padding centered-text">
                  <img className="square icon-40 checkmark" src={GeneralAssetUrl+'square-grid.png'} onClick={(e)=>this.selectStyle("tophat")} style={{margin:'auto'}}  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="large-padding-top extra-large-padding-bottom light-grey-background">
          <div className="small-padding centered-text">
            <h3>{'Select Your Accessories'}</h3>
          </div>
          <div className="row light-grey-background">
            {this.state.products && this.state.products.map((data:any,index:any) =>{
              return(
                <div className="small-12 medium-4 large-3 tiny-padding">
                  <div className={data.selected ? "selected" : "deselected"} style={{height:'100%'}}>
                    <div className="white-background centered-text" style={{height:'100%'}}>
                      <img className="full-width" style={{maxWidth:"200px"}} src={prodAssetUrl+data.attributes.slug+'1.png'} />
                      <div className="tiny-padding centered-text">
                        <p>{data.attributes.content[0].title}</p>
                        <h6 className="subheading tiny-top-margin">{data.attributes.content[0].price}</h6>
                      </div>
                      <div className="tiny-padding" style={{"borderTop":"1px solid rgba(0,0,0,.05)"}}>
                        <div className="row">
                          <div className="small-3">
                            <img className="square icon-40 checkmark" src={GeneralAssetUrl+"square-grid.png"} onClick={()=>this.updateAccessories(index)} />
                          </div>
                          <div className="small-6" style={{display:"flex", alignItems:"center",justifyContent:"flex-end",paddingRight:"10px",fontSize:"13px"}}>
                            {'Quantity'}
                          </div>
                          <div className="small-3">
                            <input type="text" className="full-width" value={data.quantity} onChange={(e)=>this.updateAccessoryQuantity(index, e.target.value)} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div className="black-background right-text calculator-footer" style={{position:"fixed", bottom:"0", width:"100%", zIndex:"100"}}>
          <div className="row">
           <div className="small-12 medium-7 right-text tiny-padding" style={{textAlign:'right', display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
             <h5 className="white" style={{paddingTop:'5px'}}>
               <span className="subheading">{"Custom Sac Price "}</span>
               {this.state.price &&
               <span>
                {'$'+this.state.price}
               </span>
             }

             </h5>
           </div>
           <div className="small-12 medium-5 tiny-padding">
             <div className="row">
               <div className="small-12 medium-6" style={{paddingRight:'5px'}}>
                 <div className="button grey-background black half-white-button full-width centered-text" onClick={this.clearLocalStorage}>{'Reset'}</div>
               </div>
               <div className="small-12 medium-6">
                 <a className="button white-background black full-width centered-text" href={'/calculatorSend'}>{'Submit Order'}</a>
               </div>
             </div>
           </div>
         </div>
       </div>
      </div>
    );
  }
}

export default FatsacCalculator;
